import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { MyStorySection } from './components/MyStorySection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { SkinResultsSection } from './components/SkinResultsSection';
import { ProductCatalog } from './components/ProductCatalog';
import { ResultsSection } from './components/ResultsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { useSeo } from './hooks/useSeo';
export function App() {
  useSeo();
  return <main className="min-h-screen bg-brand-cream selection:bg-brand-sage selection:text-white" data-id="element-0" data-mp="28tmg367fagyt">
      <Navbar data-id="element-1" data-mp="23w4fc33k781w" />
      <HeroSection data-id="element-2" data-mp="23u9q4cl98ts0" />
      <MyStorySection data-id="element-3" data-mp="23v2rey1g2r2r" />
      <ProblemSection data-id="element-4" data-mp="23ti7018ugoim" />
      <SolutionSection data-id="element-5" data-mp="3ikh8gaq64uzi" />
      <SkinResultsSection data-id="element-6" data-mp="3iiwfuqnezm4a" />
      <ProductCatalog data-id="element-7" data-mp="3ijpcuzwkmx98" />
      <ResultsSection data-id="element-8" data-mp="3mlja0y7k5j4n" />
      <TestimonialsSection data-id="element-9" data-mp="3ml12v6jcxkhy" />
      <FAQSection data-id="element-10" data-mp="3mk85gw6ag7ch" />
      <FinalCTASection data-id="element-11" data-mp="3mjq3rk0ux0x6" />
      <Footer data-id="element-12" data-mp="3rc9du70c5dx8" />
    </main>;
}